<template>
  <div class="update-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap params-wrap">
        <el-form
          label-width="120px"
          :model="devices"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="尺寸" prop="size">
            <el-input
              v-model.trim="devices.size"
              class="fl"
              style="width: 300px"
              placeholder="输入尺寸"
            ></el-input>
          </el-form-item>
          <el-form-item label="型号">
            <ul>
              <li
                class="devicesModel-item"
                v-for="(item, index) in devicesModel"
                :key="index"
              >
                <el-input
                  type="text"
                  v-model.trim="item.model"
                  placeholder="输入型号"
                />
                <div class="devicesModel-item-btn">
                  <i
                    class="el-icon-plus"
                    v-if="index === devicesModel.length - 1"
                    @click="addParam"
                    title="添加项"
                  ></i>

                  <i
                    class="el-icon-minus"
                    v-if="index > 0"
                    @click="deleteParam(index)"
                    title="删除项"
                  ></i>
                </div>
              </li>
            </ul>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      devices: {
        size: "",
        models: []
      },
      devicesModel: [{ model: "" }],
      rules: {
        size: [
          {
            required: true,
            message: "尺寸不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.create();
        } else {
          return false;
        }
      });
    },

    async create() {
      this.devices.models = [];
      for (let item of this.devicesModel) {
        this.devices.models = [...this.devices.models, item.model];
      }
      if (!this.devices.models.length) {
        this.elMsg("请至少添加一个型号", "warning");
        return;
      }
      try {
        await this.$http.createDevicesModel(this.devices);
        this.elMsg(this.$t("alertMsg.saveSuccess"), "success");
        this.$router.back();
      } catch (error) {
        this.elMsg(this.$t("alertMsg.saveFailure"), "error");
      }
    },

    addParam() {
      const obj = {
        model: ""
      };
      this.devicesModel = [...this.devicesModel, obj];
    },

    deleteParam(index) {
      this.devicesModel.splice(index, 1);
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.update-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    &.params-wrap {
      ul.parms-list {
        margin-top: 0;
      }
      .el-form-item--small .el-form-item__content {
        float: left;
        margin-left: 0 !important;
      }
    }
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .update-import-btn {
        margin-top: 10px;
      }
      .update-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
.devicesModel-item {
  position: relative;
  margin-bottom: 20px;
  .devicesModel-item-btn {
    width: 40px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    right: -50px;
    transform: translate(0, -50%);
    > i {
      cursor: pointer;
    }
  }
}
</style>
